import { InjectionToken } from '@angular/core';
import { ChatAvailabilityStore } from '../chat-availability.store';
import { ChatConnectionStore } from '../chat-connection.store';
import { ChatDataStore } from '../chat-data.store';
import { ChatUIStore } from '../chat-ui.store';

export const CHAT_UI_STORE = new InjectionToken<InstanceType<typeof ChatUIStore>>('ChatUIStore');
export const CHAT_CONNECTION_STORE = new InjectionToken<InstanceType<typeof ChatConnectionStore>>(
  'ChatConnectionStore'
);
export const CHAT_DATA_STORE = new InjectionToken<InstanceType<typeof ChatDataStore>>('ChatDataStore');
export const CHAT_AVAILABILITY_STORE = new InjectionToken<InstanceType<typeof ChatAvailabilityStore>>(
  'ChatAvailabilityStore'
);
